<template>
    <div>
        <el-dialog title="线索录入" :visible.sync="showUpdate" width="600px" :close-on-click-modal="false" center>
            <el-form label-width="120px" :model="updateClue" ref="updateClue" :rules="rules">
                <el-form-item label="城市" prop="cityId">
                    <el-select v-model="updateClue.cityId" clearable placeholder="请选择城市" filterable @change="cityChange">
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="服务者名称" prop="workerName">
                    <el-input v-model="updateClue.workerName" placeholder="请输入服务者姓名" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="服务者身份证" prop="idCard">
          <el-input v-model="updateClue.idCard" maxlength="18" placeholder="请输入服务者身份证" clearable></el-input>
        </el-form-item> -->
                <el-form-item label="服务者电话" prop="tel">
                    <el-input v-model="updateClue.tel" maxlength="11" placeholder="请输入服务者电话" clearable></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="idCard">
                  <el-input v-model="updateClue.idCard"   maxlength="18" show-word-limit placeholder clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="服务者类型" prop="workerType">
                    <el-select v-model="updateClue.workerType" style="width:100%" clearable placeholder="请选择服务类型" filterable>
                        <el-option v-for="(item,index) in workTypes" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="求职意向" prop="joinDemands">
                    <el-select v-model="updateClue.joinDemands" style="width:100%" multiple clearable placeholder="请选择服务类型" filterable>
                        <el-option v-for="(item,index) in workTypes" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="来源类型" prop="sourceType">
                    <el-radio-group v-model="updateClue.sourceType"  :disabled="operType==1" @change="chooseSourceType">
                        <el-radio :label="3">自招</el-radio>
                        <el-radio :label="4">转介绍</el-radio>
                        <el-radio :label="1">渠道</el-radio>
                        <!-- <el-radio :label="2">合伙人</el-radio> -->
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="来源" prop="sourceRelationId">
                    <el-select v-model="updateClue.sourceRelationId" style="width:100%" @change="sourceRelationChange" clearable placeholder="请选择来源" filterable>
                        <template v-for="(item,index) in supplierList">
                            <el-option v-if="item.sourceType==updateClue.sourceType" :key="index" :label="item.name+item.tel" :value="item.id+''"></el-option>
                        </template>
                    </el-select>
                    <div>*来源为服务者线索来源提供者，请如实填写</div>
                </el-form-item>
                <el-form-item label="归属" prop="workerBelongId">
                    <el-select v-model="updateClue.workerBelongId" style="width:100%" @change="workerBelongChange" clearable placeholder="请选择归属" filterable>
                        <template v-for="(item,index) in supplierList">
                            <el-option v-if="item.sourceType==1&&item.id==1327" :key="index" :label="item.name" :value="item.id+''"></el-option>
                        </template>
                    </el-select>
                    <div>*请选择要输送服务者去哪家公司</div>
                    <div>注意：如果归属选择自己公司，此服务者仅您账号可见</div>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showUpdate = false">关闭</el-button>
                <el-button type="primary" @click="saveCreate">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import {
  validatePhoneTwo,
  validateIdNo,
  validateIdNotmust,
  validateIdNoOrNull,
  validateNumber,
} from "@/script/validator";

let vm;
export default {
    data() {
        return {
            operType:0,
            sourceName: { 1: "渠道", 2: "合伙⼈", 3: "公司BD", 4: "转介绍" },
            workTypes: [
                { value: 1, label: "保洁" },
                { value: 2, label: "保姆" },
                { value: 3, label: "品类" },
            ],
            cityList: [],
            supplierList:[],
            showUpdate: false,
            updateClue: {
                addType: 2,
                cityId: "",
                workerName: "",
                workerType: "",
                sourceType: 3,
                idCard: "",
                tel: "",
                sourceRelationId: "",
                sourceRelationName: "",
                workerBelongId: "",
                workerBelongName: "",
                workerType: "",
                joinDemands: [],
                ofJz: null,
                idCard:null,
            },
            rules: {
                cityId: [
                    {
                        required: true,
                        message: "请选择城市",
                        trigger: "change",
                    },
                ],
                workerName: [
                    {
                        required: true,
                        message: "请输入服务者名称",
                        trigger: "change",
                    },
                ],
                tel: [
                    {
                        required: true,
                        message: "请输入服务者联系方式",
                        trigger: "change",
                    },
                ],
                idCard:[
                {
                    validator: validateIdNotmust,
                    message: "身份证号码格式错误",
                    trigger: "change",
                },
                ],
                sourceType: [
                    {
                        required: true,
                        message: "请选择服务者来源类型",
                        trigger: "change",
                    },
                ],
                sourceRelationId: [
                    {
                        required: true,
                        message: "请选择服务者来源",
                        trigger: "change",
                    },
                ],
                workerBelongId: [
                    {
                        required: true,
                        message: "请选择服务者归属",
                        trigger: "change",
                    },
                ],
                joinDemands: [
                    {
                        required: true,
                        message: "请选择求职意向",
                        trigger: "change",
                    },
                ],
                // workerType: [
                //     {
                //         required: true,
                //         message: "请选择服务者类型",
                //         trigger: "change",
                //     },
                // ],
            },
        };
    },
    beforeCreate() {
        vm = this;
    },
    methods: {
        chooseSourceType(){
            this.updateClue.sourceRelationId=null;
            this.updateClue.sourceRelationName=null;
        },
        showAddWorkerClue(addType,operType) {
            //add_type 1是公海，2是我的线索录入
            //operType=1 是合伙人推荐保洁师
            this.operType=operType;
           
            this.getAllCity();
            this.getSupplierList();

            this.showUpdate = true;
            this.updateClue = {
                addType: addType,
                cityId: "",
                cityName: "",
                workerName: "",
                workerType: "",
                sourceType: 3,
                idCard: "",
                tel: "",
                sourceRelationId: "",
                sourceRelationName:null,
                workerBelongId: "",
                workerBelongName:null,
                workerType: "",
                joinDemand: [],
                ofJz: null,
                idCard:null,
                operUserId: globalData.userInfo.id,
                operUserName: globalData.userInfo.userName,
            };

            if(operType==1){
                //合伙人推荐
                this.updateClue.sourceType=1;
                this.updateClue.sourceRelationId=globalData.franchisee.id+'';
                this.updateClue.sourceRelationName=globalData.franchisee.franchiseeShortName;
            }
 
           
        },
        saveCreate() {
            console.info(this.updateClue);
            this.$refs["updateClue"].validate((valid) => {
                if (valid) {
                    console.log(this.updateClue);
                    this.updateClue.joinDemand =
                        this.updateClue.joinDemands.join(",");
                    workercrmapi
                        .$axiosAddWorkerClue(this.updateClue)
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.showUpdate = false;
                                  this.$parent.querySearch();
                            } else {
                                this.$message.error(res.data.data);
                            }
                        });
                }
            });
        },

        workerBelongChange(value) {
            this.supplierList.forEach((item) => {
                if (item.id == value&&item.sourceType==1) {
                    this.updateClue.ofJz = item.companyId;

                    this.updateClue.workerBelongName = item.name;
                }
            });
        },
        sourceRelationChange(value) {
            this.supplierList.forEach((item) => {
                if (item.id == value&&item.sourceType==this.updateClue.sourceType){  
                    this.updateClue.sourceRelationName = item.name;
                }
            });
        },

        cityChange(value) {
            this.cityList.forEach((item) => {
                if (item.id == value) this.updateClue.cityName = item.cityName;
            });
        },
         getSupplierList() {
            //获取归属
            workercrmapi
                .$axiosGetSupplierList({ companyId: globalData.company.id })
                .then((res) => {
                    this.supplierList = res.data.data;
                });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity().then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
    },
};
</script>
<style>
</style>
